import { useRouteError } from 'react-router-dom';

import { AppContentFallback } from './statuses/AppContentFallback';

export const RouteError = () => {
	const error = useRouteError();

	return <AppContentFallback error={error} />;
};
